import axiosInstance from "./baseUrl";

export const loginService = async ({
  email,
  password,
}: {
  email: string;
  password: string;
}) => {
  const response = await axiosInstance.post("/v1/auth/login", {
    email,
    password,
  });
  return response.data;
};

export const sendOtp = async (signUpData: any) => {
  const response = await axiosInstance.post(
    "/v1/auth/send_verify_email",
    signUpData
  );
  return response.data;
};
export const verifyOtp = async (signUpData: any) => {
  const response = await axiosInstance.post(
    "/v1/auth/verify_email",
    signUpData
  );
  return response.data;
};
export const signupService = async (signUpData: any) => {
  const response = await axiosInstance.post(
    "/v1/auth/register_marketer",
    signUpData
  );
  return response.data;
};
